<template>
    <div class="message">
        <div class="modal fade" id="myModalMessage" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                <div class="modal-header text-center">
                    <h4 class="modal-title text-title">{{message.title}}</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body text-center text-message">
                    {{message.message}}
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'message',
    components: {},
    props: {
        message:{
            title: {
                type: String,
                default: ''
            },
            message: {
                type: String,
                default: ''
            }
        },
        isActive: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {}
    },
    created () {},
    methods: {},
    watch:{
        isActive(){
            console.log(this.message.message)
            $('#myModalMessage').modal('toggle')
        }
    }
}
</script>

<style lang="scss" scoped>
.modal-dialog {
    top: 0px !important;
}
.text-title{
    font-size: 1.5rem;
}
.text-message{
    font-size: 1.3rem;
}
</style>